import { IRemoteVideoMetadata } from '@ninjacart/nc-nk-store';
import { IFeedOrStreamComment } from '@ninjacart/nc-nk-store';
import {
  Avatar,
  Card,
  Paragraph,
  Text,
  View,
  XStack,
  useTheme,
  useTimeAgo,
} from '@ninjacart/nc-nk-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';

const StreamComments = ({
  item,
  index,
  profileName,
}: {
  item: IRemoteVideoMetadata;
  index: number;
  profileName: string;
}) => {
  const [showFullContentArray, setShowFullContentArray] = useState<boolean[]>([]);
  const [commentsData, setCommentsData] = useState<IFeedOrStreamComment[]>([]);
  const theme = useTheme();
  const { t } = useTranslation();

  const toggleExpansion = (index) => {
    // setShowFullContent(!showFullContent);
    // setShowFullContent(prevState => !prevState);
    setShowFullContentArray((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
    setCommentsData((prevCommentsData) => {
      const updatedCommentsData = [...prevCommentsData];
      updatedCommentsData[index] = {
        ...updatedCommentsData[index],
        showFullContent: !updatedCommentsData[index]?.showFullContent,
      };
      return updatedCommentsData;
    });
  };

  const renderContent = (comments, index) => {
    if (!comments?.commentText) return null;
    const maxLength = 100;

    const normalizedContent = `${comments?.commentText}`;

    const truncatedContent =
      normalizedContent?.length > maxLength
        ? normalizedContent?.substring(0, maxLength) + '...'
        : normalizedContent;

    return (
      <Pressable
        style={{ paddingHorizontal: 10, paddingVertical: 16 }}
        onPress={() => toggleExpansion(index)}
        testID="kisan_tId_comment_toggle_click"
      >
        <Paragraph color={theme['darkLight']?.val}>
          {showFullContentArray[index] ? normalizedContent : truncatedContent}
        </Paragraph>
        {normalizedContent?.length > maxLength && (
          <Text color={'$primary'}>
            {showFullContentArray[index] ? t('page.readLess') : `${t('page.readMore')}...`}
          </Text>
        )}
      </Pressable>
    );
  };

  const renderCommentsHeader = (comments) => {
    return (
      <Card.Header padded display="flex">
        <XStack>
          <Avatar circular size="$5">
            <Avatar.Image accessibilityLabel={comments?.name} src={comments?.avatar} />
            <Avatar.Fallback delayMs={600} />
          </Avatar>
          <XStack flexDirection="column" paddingLeft={10} paddingTop={1}>
            <Paragraph fontSize={16} color={'$usertextColor'} style={{ fontWeight: '700' }}>
              {profileName}
            </Paragraph>
            <Paragraph fontSize={13} style={{ fontWeight: '500' }} color={'$darkGrey'}>
              {comments?.created_at && useTimeAgo(comments?.created_at)}
            </Paragraph>
          </XStack>
        </XStack>
      </Card.Header>
    );
  };

  return (
    <>
      <View style={{ height: '97%', width: '100%' }}>
        <XStack key={index} marginBottom={5} paddingHorizontal={3}>
          <Card
            backgroundColor={'$cardbackground'}
            elevate
            size="$2"
            paddingHorizontal="$2"
            paddingTop="$2"
            elevation={5}
            shadowOpacity={0.2}
            width={'100%'}
          >
            {renderCommentsHeader(item)}
            {renderContent(item, index)}
          </Card>
        </XStack>
      </View>
    </>
  );
};

export default StreamComments;
